module.exports = __webpack_public_path__ + "static/media/pickups.2effc1f0.png";